import React, { useEffect, useState } from "react";
import Header from "./header";
import Footer from "components/layout/footer/index";
import { useLocation } from "@reach/router";
import setCookie from "utils/setCookie";
import FooterCopyRight from "./footer/FooterCopyRight";
import Cookie from "components/popup/cookiePopup/Cookie";
import ManageCookie from "components/popup/cookiePopup/ManageCookie";
import { useContext } from "react";
import DataContext from "Context/DataContext";
import { Toaster } from "react-hot-toast";

export default function Layout({ children, isFooter = true }) {
  const location = useLocation();
  const {
    toggleStates,
    setToggleStates,
    showCookie,
    setShowCookie,
    cookiePreference,
    setCookiePreference,
  } = useContext(DataContext);

  // useEffect(() => {
  //   if (showCookie) {
  //     document.body.classList.add("move-chat-bot-up");
  //   } else {
  //     document.body.classList.remove("move-chat-bot-up");
  //   }
  //   const whatsappWidget = document.getElementsByClassName("whatsapp-float");
  //   if (whatsappWidget && whatsappWidget[0]) {
  //     const screenSize = window.screen.width;
  //     whatsappWidget[0].style.bottom =
  //       showCookie && screenSize >= 1024
  //         ? "150px"
  //         : showCookie && screenSize > 799 && screenSize < 1024
  //         ? "205px"
  //         : showCookie && screenSize < 799 && screenSize > 419
  //         ? "220px"
  //         : showCookie && screenSize <= 420
  //         ? "230px"
  //         : "100px";
  //   }
  // }, [showCookie]);

  useEffect(() => {
    const updateZIndex = () => {
      const salesIQElement = document.querySelector('[data-id="zsalesiq"]');
      if (salesIQElement) {
        salesIQElement.style.setProperty("z-index", "1000", "important");
      }
    };
    updateZIndex();
    // Observe changes in the DOM in case SalesIQ is dynamically injected
    const observer = new MutationObserver(updateZIndex);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  // const acceptAllCookie = () => {
  //   setToggleStates({
  //     analyticsCookies: true,
  //     functionalCookies: true,
  //     advertisingCookies: true,
  //   });

  //   localStorage.setItem("analyticsCookies", "true");
  //   localStorage.setItem("functionalCookies", "true");
  //   localStorage.setItem("advertisingCookies", "true");
  //   localStorage.setItem("cookiePopup", "true");
  // };

  // const rejectAllCookie = () => {
  //   setToggleStates({
  //     analyticsCookies: false,
  //     functionalCookies: false,
  //     advertisingCookies: false,
  //   });

  //   localStorage.setItem("analyticsCookies", "false");
  //   localStorage.setItem("functionalCookies", "false");
  //   localStorage.setItem("advertisingCookies", "false");
  //   localStorage.setItem("cookiePopup", "true");
  // };

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("cookiePopup"));
    if (!items) {
      setTimeout(() => {
        setShowCookie(true);
      }, 100);
    }
  }, []);

  // useEffect(() => {
  //   typeof window !== "undefined" &&
  //     typeof window.gtag !== "undefined" &&
  //     window.gtag("consent", "default", {
  //       ad_storage: "denied",
  //     });

  //   // gtag("consent", "default", {
  //   //   ad_storage: "denied",
  //   // });

  //   const adValue = JSON.parse(localStorage.getItem("advertisingCookies"));
  //   const analyticsValue = JSON.parse(localStorage.getItem("analyticsCookies"));
  //   const functionalValue = JSON.parse(
  //     localStorage.getItem("functionalCookies")
  //   );

  //   if (adValue === true) {
  //     typeof window !== "undefined" &&
  //       typeof window.gtag !== "undefined" &&
  //       window.gtag("consent", "update", {
  //         ad_storage: "granted",
  //       });
  //   }

  //   // if (adValue === false) {
  //   //   console.log("else block ad");
  //   //   typeof window !== "undefined" &&
  //   //     typeof window.gtag !== "undefined" &&
  //   //     window.gtag("consent", "update", {
  //   //       ad_storage: "denied",
  //   //     });
  //   // }
  //   // if (analyticsValue === true) {
  //   //   console.log("if block");
  //   //   typeof window !== "undefined" &&
  //   //     typeof window.gtag !== "undefined" &&
  //   //     window.gtag("consent", "update", {
  //   //       analytics_storage: "granted",
  //   //     });
  //   // } else {
  //   //   console.log("else block");
  //   //   typeof window !== "undefined" &&
  //   //     typeof window.gtag !== "undefined" &&
  //   //     window.gtag("consent", "default", {
  //   //       ad_storage: "denied",
  //   //     });
  //   // }

  //   if (analyticsValue === true || adValue === true) {
  //     typeof window !== "undefined" && window.clarity("consent");
  //   }
  // }, [toggleStates]);

  const urlSearchParams = new URLSearchParams(location.search);
  const {
    utm_source,
    utm_campaign,
    utm_agid,
    utm_term,
    creative,
    device,
    placement,
    utm_medium,
  } = Object.fromEntries(urlSearchParams.entries());

  setCookie("utm_source", utm_source, 3);
  setCookie("utm_campaign", utm_campaign, 14);
  setCookie("utm_agid", utm_agid, 14);
  setCookie("utm_term", utm_term, 14);
  setCookie("creative", creative, 14);
  setCookie("device", device, 14);
  setCookie("placement", placement, 14);
  setCookie("utm_medium", utm_medium, 14);

  return (
    <>
      <Header />
      {children}
      {showCookie && !cookiePreference && (
        <Cookie
          setShowCookie={setShowCookie}
          setCookiePreference={setCookiePreference}
        />
      )}
      {cookiePreference && <ManageCookie />}
      {isFooter ? <Footer /> : null}
      <FooterCopyRight whatsappBot={true} />
      <Toaster
        toastOptions={{
          className: "rounded",
        }}
      />
    </>
  );
}
